<template>
    <div v-if="item">
        <AppHeader closeable="true" title="News feed" :redirectOnClose="'/news'"></AppHeader>

        <section class="container container-lg">
            <figure class="figure mb--lg" v-if="item.image">
                <img :src="item.image"/>
            </figure>

            <h1 class="text--center mb--0">{{ item.title }}</h1>

            <h2 class="h3 text--center c--primary mb--lg" v-if="item.tag">{{ item.tag }}</h2>

            <p v-html="item.description"></p>

            <router-link to="/new-game" class="btn btn--block btn--primary mt--30 mb--lg">
                Start new game
            </router-link>
        </section>
    </div>
</template>

<script>
    import AppHeader from "./partial/AppHeader";
    import api from "../api/news";

    export default {
        name: "NewsPage",
        components: {AppHeader},
        props: {
            slug: {
                required: true
            }
        },
        data: function () {
            return {
                item: null
            }
        },
        methods: {
            async search() {
                try {
                    let response = await api.show(this.slug);

                    this.item = response.data.item;
                } catch (error) {
                    if (error.response.status === 404) {
                        this.$router.push('/404')
                    }
                }
            }
        },
        created() {
            this.search();
        }
    }
</script>